import { defaultApiState } from '../api.state';

export const reviewMutations = {
  GET_REVIEWS_LOADING(state) {
    state.apiState.getReviews = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_REVIEWS_SUCCESS(state, payload) {
    state.apiState.getReviews = {
      ...defaultApiState,
      success: true,
    };
    state.reviews = payload;
  },
  GET_REVIEWS_ERROR(state, error) {
    state.apiState.getReviews = {
      ...defaultApiState,
      error,
    };
  },
  APPROVE_REVIEW_LOADING(state) {
    state.apiState.approveReview = {
      ...defaultApiState,
      loading: true,
    };
  },
  APPROVE_REVIEW_SUCCESS(state) {
    state.apiState.approveReview = {
      ...defaultApiState,
      success: true,
    };
  },
  APPROVE_REVIEW_ERROR(state, error) {
    state.apiState.approveReview = {
      ...defaultApiState,
      error,
    };
  },
  REJECT_REVIEW_LOADING(state) {
    state.apiState.rejectReview = {
      ...defaultApiState,
      loading: true,
    };
  },
  REJECT_REVIEW_SUCCESS(state) {
    state.apiState.rejectReview = {
      ...defaultApiState,
      success: true,
    };
  },
  REJECT_REVIEW_ERROR(state, error) {
    state.apiState.rejectReview = {
      ...defaultApiState,
      error,
    };
  },
};
